// LICENSE_CODE ZON
'use strict'; /*jslint ts:true, react:true*/
import React, {Fragment, useContext, useEffect, useMemo,
  useState} from 'react';
import cn from 'classnames';
import {Settings_context} from '../../../settings_ctx';
import {statuses} from '../../../data_ctx';
import etask from 'zetask';
import {use_data_provider} from '../../../lib/use_data_provider';
// @ts-ignore
import {fetch} from '/util/fetch.js';
import {get_article_date, i_article, i_article_result} from '../../../ui/blog/i_blog';
import {Link, useHistory} from 'react-router-dom';
// @ts-ignore
import {perr_www_visit} from '/www/hola/pub/util.js';
// @ts-ignore
import {App_context} from '/www/hola/pub/context.js';
import {Spacer} from '../../../ui/homepage/spacer';
import {use_article_links} from '../../../ui/blog/use_article_links';
import Icon_facebook from '../../../img/hola2023/icons/32/facebook.svg';
import Icon_twitter from '../../../img/hola2023/icons/32/twitter.svg';
import Icon_linkedin from '../../../img/hola2023/icons/32/linkedin.svg';
import Icon_copy from '../../../img/hola2023/icons/32/copy.svg';
import Icon_chevron_left from '../../../img/hola2023/icons/16/chevron_left.svg';
import {Media_block} from '../../../ui/media_block';
import {Article_card} from '../../../ui/blog/article_card';
import {Install_btn} from '../../../ui/install_btn';
import {Agree_dialog} from '../../../shared/agree_dialog/agree_dialog';
import {use_pathname} from '../../../lib/use_pathname';

import styles from './article.module.less';

const get_data_id = params=>`/blog/article/slug/${params.slug}/id/${params.id}`;

const Author = ({art})=>{
  const {theme} = useContext(Settings_context);
    return art && !art.error ? <div className={styles.author}>
        <div className={styles.author_pic}
          style={{backgroundImage: `url(${art.data.author?.img})`}}/>
        <p className={cn(theme.u4, styles.author_text)}>
          {art.data.author?.name}<br/>
          {art.data.author?.position}
        </p>
    </div> : null;
};

const Share = ({art})=>{
    const {facebook_link, twitter_link, linkedin_link,
        copy} = use_article_links({
        article_id: art.data.id,
        article_title: art.data.title,
    });
    const on_copy_link = ev=>{
        ev.preventDefault();
        copy();
    };
    return <div className={styles.share}>
      <a href={twitter_link}><Icon_twitter/></a>
      <a href={facebook_link}><Icon_facebook/></a>
      <a href={linkedin_link}><Icon_linkedin/></a>
      <a href="#" onClick={on_copy_link}><Icon_copy/></a>
    </div>;
};

const Back_btn = ()=>{
  const {theme} = useContext(Settings_context);
  const history = useHistory();
  const {params} = use_pathname();
  return <button className={styles.back_btn} onClick={()=>{
    if (params.category && params.category !='all')
      return void history.push(`/blog/${params.category}`);
    history.push('/blog');
    }}>
    <Icon_chevron_left/><span className={cn(theme.P, theme.p2, theme.med)}>
      Back</span>
  </button>;
};

export const Root = props=>{
  const {theme} = useContext(Settings_context);
  // @ts-ignore
  const {user} = useContext(App_context);
  const {params} = use_pathname();
  const history = useHistory();
  const {data} = use_data_provider(get_data_id);
  const article = props as i_article;
  const [art, set_art_result] = useState<i_article_result | null>(null);
  const visited = useMemo(()=>({}), []);

  useEffect(()=>{
    if (article && article.slug)
      set_art_result({data: article, error: ''});
    if (data && data.status === statuses.done)
    {
      set_art_result(data.result);
      // redirect to canonical URL if category doesn't match
      if (data.result.data?.categories?.[0]?.slug &&
        params.category != data.result.data.categories[0].slug)
      {
        history.replace(`/blog/${data.result.data.categories[0].slug}/${params.slug}`);
        return;
      }
      if (data.result.data && !visited[data.result.data.id])
      {
        visited[data.result.data.id] = true;
        perr_www_visit({
          id: `www_blog_article_${data.result.data.id}_visit`,
          user,
        });
        fetch(`/cms_api/blog/read_post?id=${data.result.data.id}`);
      }
    }
  }, [article, data]);

  // if (!art)
  //   return <p>Loading...</p>;

  const cta_cls = cn(
    'hola_btn hola_btn--round hola_btn--txt_colored',
    'hola_btn--no_jump',
    styles.promo_cta
  );

  return (
    <div className={cn(theme.root, styles.root)}>
      <div className={styles.article}>
        {art && !art.error &&
          <div className={styles.article_header}>
            <Back_btn />
            <p className={cn(theme.p2, theme.med, styles.breadcrumbs)}>
              {art.data?.categories && art.data?.categories[0] &&
                <Link
                  className={styles.link}
                  to={`/blog/${art.data.categories[0].slug}`}
                >
                  {art.data.categories[0].name}
                </Link>
              }
              <svg xmlns="http://www.w3.org/2000/svg" width="4" height="4"
                viewBox="0 0 4 4" fill="none">
                <circle cx="2" cy="2" r="2" fill="#ABABAB" />
              </svg>
              {art.data.time_to_read} read
            </p>
            <p className={cn(theme.u3, theme.reg, styles.date)}>
              {get_article_date(art.data)}
            </p>
            <h1
              className={cn(theme.H3, styles.title)}
              dangerouslySetInnerHTML={{__html: art.data.title}}
            />
          </div>
        }
        {art && !art.error ?
          <Fragment>
            {art.data.img &&
              <div className={styles.img_art}>
                <img src={art.data.img} alt="article_img"
                  className="lazyload"/>
              </div>
            }
            <div className={styles.after_img}>
              <Author art={art} />
              <Share art={art} />
            </div>
            <div
              className={styles.article_body}
              dangerouslySetInnerHTML={{__html: art.data.content}}
            ></div>
          </Fragment> :
          <span>{art && art.error}</span>
        }
      </div>
      <Spacer />
      <div className={styles.promo}>
        <div className={theme.container}>
          <Media_block
            img="blog/arc_img.svg"
            title="blog.media.title"
            text="blog.media.text"
            reversed
            cls={{
              title: cn(theme.H4, theme.primary),
              content: styles.promo_content,
              text: cn(theme.u3, styles.promo_text),
              img: styles.promo_img,
            }}
          >
            <Install_btn
              src="blog"
              className={cta_cls}
              user_country={props.user_country}
              agree_dialog={Agree_dialog}
            />
          </Media_block>
        </div>
      </div>
      <Spacer />
      {/* @ts-ignore */}
      {art?.data?.recent_posts &&
        <div className={theme.container}>
          <div className={styles.recent}>
            <h5 className={cn(theme.reg, styles.recent_title)}>
              You might like these, too
            </h5>
            <div className={styles.recent_list}>
              {/* @ts-ignore */}
              {art.data?.recent_posts.map(p=>
                <Article_card key={p.id} {...p} />
              )}
            </div>
          </div>
        </div>
      }
      <Spacer />
      <Spacer />
    </div>
  );
};
Root.meta = {
    ssr_force: true,
    nosearch: true,
    meta: props=>{
        if (props.data_from_provider && props.data_from_provider[0])
        {
            const {category} = props;
            const article_data = props.data_from_provider[0];
            const seo_data = article_data?.data?.seo;
            const seo_title = seo_data?.title ||
                article_data?.data?.title;
            const seo_description = seo_data?.description ||
                article_data?.data?.excerpt;
            const seo_keywords = seo_data?.keywords || '';
            const seo_date = article_data?.data?.datetime?.date;
            return {
                title: seo_title,
                canonical_url: 'https://hola.org/blog/'+category+'/'+
                    article_data?.data?.slug,
                og_title: seo_title,
                description: seo_description,
                keywords: seo_keywords,
                og_description: seo_description,
                og_url: 'https://hola.org/blog/'+category+'/'+
                  article_data?.data?.slug,
                og_image: article_data?.data?.img,
                author: article_data?.data?.author?.name,
                published_time: seo_date && new Date(seo_date).toISOString(),
            };
        }
        return {
            title: 'Article',
            canonical_url: '/blog/article/slug/',
        };
    },
    set_data_cache: (data_cache, params, data)=>{
        data_cache[`/blog/article/slug/${params.slug}/id/${params.id}`] = data;
    },
    get_data_id,
    data_provider: (data_cache, params)=>etask(function*(){
        const cache_key = `/blog/article/slug/${params.slug}/id/${params.id}`;
        const cached = data_cache[cache_key];
        if (cached)
            return cached;
        if (!params.id && !params.slug)
            return {data: {}, error: 'article id should be specified'};
        const data = yield fetch(`https://hola.org/cms_api/blog/post/`+
            `?slug=${params.slug}&id=${params.id}`);
        if (!data || data.indexOf && data.indexOf('<!DOCTYPE')>-1)
            return {data: {}, error: 'not found', error_code: 404};
        const end = `https://hola.org/cms_api/blog/posts`;
        let recent_posts = yield fetch(`${end}?posts_per_page=3&paged=0`);
        if (typeof recent_posts!='object')
            recent_posts = {};
        recent_posts = recent_posts.posts||[];
        const result = {
            data,
            recent_posts,
            error: '',
            cache_key,
        };
        data_cache[cache_key] = result;
        return result;
    }),
};
